import request from '@/api/request'

const url = '/staff'

/**
 * 添加
 * @param data
 * @returns {AxiosPromise}
 */
export const add = (data) => {
    return request({
        url: url,
        method: 'post',
        data
    })
}

export const upload = (data, type) => {
    return request({
        url: '/upload/card/' + type,
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}